import { SearchPanel } from '@eurotunnel-pax/leshuttle.ui/src/scripts/components/patterns/search-dialog'
import { getCurrentCulture } from '../utilities/Localization'
import { debounce } from '../utilities/Debounce'

export function setupSearch () {
  const searchPanels = document.querySelectorAll('[data-search-dialog]')
  if (searchPanels.length) {
    for (const panel of searchPanels) {
      const searchPanel = new SearchPanel(panel)
      const searchBox = panel.querySelector('[data-search-input]')
      if (searchBox) {
        if (searchBox.onsearch) {
          searchBox.addEventListener('search', debounce((e) => {
            autoCompleteEvent(e.target.value, searchPanel)
          }, 300))
        } else {
          searchBox.addEventListener('keyup', debounce((e) => {
            autoCompleteEvent(e.target.value, searchPanel)
          }, 300))
        }
      }
    }
  }
}

function getSearchEndpoint (panel) {
  const type = panel?.dataset?.searchDialog ?? 'global'
  switch (type) {
    case 'support':
      return '/api2/search/support'
    case 'global':
    default:
      return '/api2/search'
  }
}

function autoCompleteEvent (searchValue, searchPanel) {
  const endpoint = getSearchEndpoint(searchPanel.elem)
  fetch(`${endpoint}?q=${searchValue}`, {
    headers: {
      'Accept-Language': getCurrentCulture()
    }
  }).then((res) => {
    if (res.ok) {
      return res.json()
    }
    throw new Error('Failed to get search results')
  })
    .then(data => {
      searchPanel.populateAutocomplete(data)
    })
    .catch((err) => {
      console.log(err)
    })
}
